import React, { useState, useEffect } from 'react';
import { HeaderLogo } from './header/HeaderLogo';
import { Navigation, scrollToSection } from './header/Navigation';
import { HeaderActions } from './header/HeaderActions';
import { MobileMenu } from './header/MobileMenu';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Mount-only listener — handleScroll & setIsScrolled are local/stable.
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSelect = (section) => {
    scrollToSection(section);
    setIsMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`} data-testid="site-header">
      <div className="header-content">
        <HeaderLogo />
        <Navigation onSelect={handleSelect} />
        <HeaderActions isMenuOpen={isMenuOpen} onToggleMenu={() => setIsMenuOpen((v) => !v)} />
      </div>
      {isMenuOpen && <MobileMenu onSelect={handleSelect} />}
    </header>
  );
};
